/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Tsb_RangeInputs */

const en_exp_tsb_range = /** @type {(inputs: Exp_Tsb_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Above +25: detraining risk. +5 to +25: fresh, race-ready. -10 to +5: normal training. -30 to -10: productive overload. Below -30: high fatigue, rest recommended.`)
};

const de_exp_tsb_range = /** @type {(inputs: Exp_Tsb_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über +25: Formverlust droht. +5 bis +25: frisch, wettkampfbereit. -10 bis +5: normales Training. -30 bis -10: produktive Überbelastung. Unter -30: hohe Ermüdung, Ruhe nötig.`)
};

/**
* | output |
* | --- |
* | "Above +25: detraining risk. +5 to +25: fresh, race-ready. -10 to +5: normal training. -30 to -10: productive overload. Below -30: high fatigue, rest recommen..." |
*
* @param {Exp_Tsb_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_tsb_range = /** @type {((inputs?: Exp_Tsb_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Tsb_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_tsb_range(inputs)
	return de_exp_tsb_range(inputs)
});